import { render, staticRenderFns } from "./TipoSolvenciaPage.vue?vue&type=template&id=415c163d"
import script from "./TipoSolvenciaPage.js?vue&type=script&lang=js&external"
export * from "./TipoSolvenciaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports